import request from '@/api/request'

// 获取首页/自定义页面配置（不传 pageId 时返回该商户默认首页）
export function getPageFull(pageId) {
  return request.get('/api/mini/browse/page', { params: pageId ? { pageId } : {} })
}

// 获取产品列表
export function getProductList(body) {
  return request.post('/api/mini/browse/product/list', body)
}

// 获取产品详情
export function getProductDetail(id) {
  return request.get(`/api/mini/browse/product/detail/${id}`)
}

// 获取 SKU 价格日历
export function getSkuPrices(params) {
  return request.get('/api/mini/browse/product/sku-prices', { params })
}

// 获取产品筛选选项（城市/价格区间/天数区间/天数分档）
export function getProductFilterOptions() {
  return request.get('/api/mini/browse/product/filter-options')
}

// 获取资讯列表
export function getArticleList(body) {
  return request.post('/api/mini/browse/article/list', body)
}

// 获取资讯详情
export function getArticleDetail(id) {
  return request.get(`/api/mini/browse/article/detail/${id}`)
}

// 获取字典数据
export function getDictByCode(typeCode) {
  return request.get('/api/mini/browse/dict/by-code', { params: { typeCode } })
}

// 获取自定义页面内容
export function getCustomPage(pageConfigId) {
  return request.get(`/api/mini/browse/custom-page/${pageConfigId}`)
}
